// Component to inject structured data into the page
export const StructuredData = ({ data }: { data: unknown }) => {
  // Safely encode JSON to prevent XSS attacks
  // JSON.stringify doesn't escape HTML characters, so we need to do it manually
  const safeJson = JSON.stringify(data)
    .replace(/</g, '\\u003c')  // Escape < to prevent script tag injection
    .replace(/>/g, '\\u003e')  // Escape > for consistency
    .replace(/&/g, '\\u0026')  // Escape & to prevent HTML entity injection

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: safeJson }}
    />
  )
}